import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import { Carousel } from 'react-responsive-carousel';
import Paragraph from "../Paragraph";
import './ComponentHero.scss';

interface Data {
    paragraphById: {
        fieldVarMobileDisplay: string;
        fieldVarMakeFullWidth: string;
        fieldInnerHeroItem: Array<{
            targetRevisionId: string
        }>;
    }
}

class ComponentHeroQuery extends Query<Data, {id: string}> {}

const GET_COMPONENT = gql`
query paragraphByRevisionId($id: String!) {
    paragraphById:paragraphRevisionById(id: $id) {
    ... on Paragraph {
      ... on Paragraph {
        ... on ParagraphComponentHero {
          fieldInnerHeroItem {
            targetRevisionId
          }
          fieldVarMobileDisplay
          fieldVarMakeFullWidth
        }
      }
    }
  }
}
`;

const ComponentHero = ({id, componentIndex, markComponentLoadedAs, handleLoadedComponents}) => (
    <ComponentHeroQuery asyncMode query={GET_COMPONENT} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return null;
            if (error) {
                markComponentLoadedAs(id, true);
                return <div>{error}</div>;
            }

            const field = data.paragraphById;
            if (!field.fieldInnerHeroItem) {
                markComponentLoadedAs(id, true);
                return null;
            }

            markComponentLoadedAs(id, true);

            return (
                <Carousel className="hero" showArrows emulateTouch showThumbs={false} showIndicators={false} showStatus={false}>
                    {!field.fieldVarMakeFullWidth ? (
                        <div className="container">
                            {field.fieldInnerHeroItem &&
                            field.fieldInnerHeroItem.map((component, index) => (
                                <Paragraph key={`${id}_${component.targetRevisionId}`}
                                           componentIndex={componentIndex}
                                           index={index}
                                           id={String(component.targetRevisionId)}
                                           handleLoadedComponents={handleLoadedComponents}/>
                            ))}
                        </div>
                    ) : field.fieldInnerHeroItem &&
                        field.fieldInnerHeroItem.map((component, index) => (
                            <Paragraph key={`${id}_${component.targetRevisionId}`}
                                       componentIndex={componentIndex}
                                       index={index}
                                       id={String(component.targetRevisionId)}
                                       handleLoadedComponents={handleLoadedComponents}/>
                        ))}
                </Carousel>
            );
        }}
    </ComponentHeroQuery>
);

ComponentHero.propTypes = {
    id: PropTypes.number.isRequired,
    componentIndex: PropTypes.number,
    markComponentLoadedAs: PropTypes.func.isRequired,
    handleLoadedComponents: PropTypes.func.isRequired
};

ComponentHero.defaultProps = {
    componentIndex: null
};

export default ComponentHero;



// WEBPACK FOOTER //
// ./frontend/components/Hero/ComponentHero.jsx